import React from 'react';
import KEYBlue from '../common/keylist-blue';

type Props = {
    title: string;
};

const ReactJsDevelopment: React.FC<Props> = ({ title }) => {
    return (
        <section className="Development-Services section-py">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="text-center lg:col-span-8 lg:col-start-3 pb-12">
                        <div className="Development-Services-head  mb-5 text-center">
                            <h2 className="fw-700 fs-xl text-center">{title}</h2>
                            <p className="fs-md text-secondary fw-400">
                                Moweb Limited is committed to providing enterprise-grade ReactJS development services that
                                empower businesses to build dynamic and responsive web and mobile applications. As a top ReactJS
                                development agency, we excel in creating single-page applications (SPA), progressive web apps
                                (PWA), and more. Our seasoned React developers understand the unique challenges faced by various
                                industries, allowing us to tailor custom solutions that cater to your specific requirements,
                                whether in healthcare, finance, eCommerce, or education.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12 xl:grid-cols-12 md:grid-cols-12 gy-10">
                    <div className="xl:col-span-6 lg:col-span-12 md:col-span-12">
                        <div className="dev-service-inner">
                            <h2 className="fw-700 fs-xl ">The Advantages of using ReactJs for Your Business</h2>
                            <p className="fs-md text-secondary fw-400">
                                ReactJS has emerged as a dominant force in frontend development, empowering businesses to create
                                modern, interactive, and engaging user interfaces. {`Here's`} why you should consider ReactJS for
                                your next project:
                            </p>
                        </div>
                    </div>
                    <div className="xl:col-span-6 lg:col-span-12 md:col-span-12">
                        <div className="row grid md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-1">
                            <div>
                                <div className="gap-2.5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
                                    <KEYBlue
                                        text={
                                            <>
                                                <p className="font-normal text-[17px]">
                                                    <span className="font-semibold text-black">Lightning-Fast Performance:</span>
                                                    {` ReactJS's`} virtual DOM efficiently updates only the necessary parts of the
                                                    page, resulting in blazing-fast web applications that enhance user experience
                                                    and boost your SEO rankings.
                                                </p>
                                            </>
                                        }
                                    />
                                    <KEYBlue
                                        text={
                                            <>
                                                <p className="font-normal text-[17px]">
                                                    <span className="font-semibold text-black">Unmatched Flexibility: </span>
                                                    {` ReactJS's`} component-based architecture allows for unparalleled
                                                    flexibility, enabling you to build anything from simple landing pages to
                                                    complex, feature-rich ReactJS Single Page Applications {`(SPAs)`}.
                                                </p>
                                            </>
                                        }
                                    />
                                    <KEYBlue
                                        text={
                                            <>
                                                <p className="font-normal text-[17px]">
                                                    <span className="font-semibold text-black">Advanced Technology Stack:</span>
                                                    We leverage the latest tools and technologies, such as HTML + CSS, JSX,
                                                    JavaScript Fundamental + ES6, Git, Node + npm, Redux, and more, to build
                                                    cutting-edge applications.
                                                </p>
                                            </>
                                        }
                                    />
                                    <KEYBlue
                                        text={
                                            <>
                                                <p className="font-normal text-[17px]">
                                                    <span className="font-semibold text-black">
                                                        Effortless Maintenance & Scalability:
                                                    </span>
                                                    {`ReactJS's`} modular structure promotes code reusability and maintainability,
                                                    making it easier to update and scale your applications as your business
                                                    evolves.
                                                </p>
                                            </>
                                        }
                                    />
                                    <KEYBlue
                                        text={
                                            <>
                                                <p className="font-normal text-[17px]">
                                                    <span className="font-semibold text-black">
                                                        Exceptional User Experiences:
                                                    </span>
                                                    Craft pixel-perfect and highly interactive UI/UX designs in ReactJS,
                                                    delivering seamless user experiences that leave a lasting impression.
                                                </p>
                                            </>
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ReactJsDevelopment;
